import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

export default {
    name: 'sidebar-item',
    components: {
        [CollapseTransition.name]: CollapseTransition
    },
    props: {
        menu: {
            type: Boolean,
            default: false
        },
        link: {
            type: Object,
            default: () => {
                return {
                    name: '',
                    path: '',
                    domainName: '',
                    children: []
                }
            }
        }
    },
    provide() {
        return {
            addLink: this.addChild,
            removeLink: this.removeChild
        }
    },
    inject: {
        addLink: { default: null },
        removeLink: { default: null },
        autoClose: {
            default: true
        }
    },
    data() {
        return {
            children: [],
            collapsed: true
        }
    },
    computed: {
        domain() {
            return this.link.domainName && this.link.domainName != ''
                                    ? process.env.url[this.link.domainName]
                                    : process.env.url.oldApp;
        },
        baseComponent() {
            return this.isMenu || this.link.isRoute ? 'li' : 'router-link'
        },
        isMenu() {
            return this.children.length > 0 || this.menu === true
        },
        isActive() {
            if (this.$route && this.$route.path) {
                let matchingRoute = this.children.find((c) => this.$route.path.startsWith(c.link.path))
                if (matchingRoute !== undefined) {
                    return true
                }
            }
            return false
        }
    },
    methods: {
        getClass(link) {
            return { 'active': link.active, 'green': link.path == window.location.pathname + window.location.hash, 'nav-link': true };
        },
        addChild(item) {
            const index = this.$slots.default.indexOf(item.$vnode)
            this.children.splice(index, 0, item)
        },
        removeChild(item) {
            const tabs = this.children
            const index = tabs.indexOf(item)
            tabs.splice(index, 1)
        },
        elementType(link, isParent = true) {
            if (link.isRoute === false) {
                return isParent ? 'li' : 'a'
            } else {
                return 'router-link'
            }
        },
        linkAbbreviation(name) {
            const matches = name.match(/\b(\w)/g)
            return matches.join('')
        },
        linkClick(link) {
            if (link.isOld) {
                window.location.href = this.domain + link.path;
                return;
            }
            if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {

                this.$sidebar.displaySidebar(false)
            }
            else {
                window.scrollTo(0, 0);
            }
        },
        getLink(link) {
            return link.isOld ? this.domain + link.path : link.path;
        },
        collapseMenu() {
            var status = !this.collapsed;
            //this.children.forEach(item => {
            //    item.collapsed = true;
            //})
            
            this.collapsed = status;
        },
        collapseSubMenu(link) {
            link.collapsed = !link.collapsed
        }
    },
    mounted() {
        if (this.addLink) {
            this.addLink(this)
        }
        if (this.link.collapsed !== undefined) {
            this.collapsed = this.link.collapsed
        }
        if (this.isActive && this.isMenu) {
            this.collapsed = false
        }
    },
    destroyed() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el)
        }
        if (this.removeLink) {
            this.removeLink(this)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/theme/SidebarPlugin/SidebarItem.js